// Admin business pages translations: AdminOrders (aOrds*), AdminDeposits (aDep*), AdminWithdrawals (aWd*)
const bizTranslations = {
  vi: {
    // AdminOrders
    aOrdsTitle: 'Quản lý Đơn hàng',
    aOrdsSubtitle: 'Thêm và quản lý đơn hàng trong pool',
    aOrdsAddOrder: 'Thêm đơn hàng',
    aOrdsPoolTitle: 'Pool Đơn Hàng',
    aOrdsPoolSubtitle: 'Quản lý tất cả sản phẩm trong pool',
    aOrdsTotalOrders: 'Tổng đơn hàng',
    aOrdsActive: 'Đang hoạt động',
    aOrdsTotalCommission: 'Tổng hoa hồng',
    aOrdsLoading: 'Đang tải...',
    aOrdsEmpty: 'Chưa có đơn hàng nào trong pool',
    aOrdsStatusActive: 'Hoạt động',
    aOrdsStatusInactive: 'Tạm dừng',
    aOrdsPrice: 'Giá tiền:',
    aOrdsCommission: 'Hoa hồng:',
    aOrdsEdit: 'Sửa',
    aOrdsDelete: 'Xóa',
    aOrdsEditOrder: 'Sửa đơn hàng',
    aOrdsAddNew: 'Thêm đơn hàng mới',
    aOrdsProductName: 'Tên sản phẩm',
    aOrdsProductNamePlaceholder: 'VD: iPhone 15 Pro Max',
    aOrdsProductImage: 'Hình ảnh sản phẩm',
    aOrdsChooseImage: 'Chọn ảnh',
    aOrdsPriceUsdt: 'Giá tiền (USDT)',
    aOrdsCommissionHint: 'Hoa hồng được tự động tính theo phần trăm cấu hình VIP của user.',
    aOrdsStatus: 'Trạng thái',
    aOrdsCancel: 'Hủy',
    aOrdsProcessing: 'Đang xử lý...',
    aOrdsUpdate: 'Cập nhật',
    aOrdsUpdateSuccess: 'Cập nhật đơn hàng thành công!',
    aOrdsCreateSuccess: 'Thêm đơn hàng thành công!',
    aOrdsErrorOccurred: 'Có lỗi xảy ra!',
    aOrdsDeleteConfirm: 'Bạn có chắc muốn xóa đơn hàng này?',
    aOrdsDeleteSuccess: 'Xóa đơn hàng thành công!',
    aOrdsDeleteFailed: 'Không thể xóa đơn hàng!',
    // AdminDeposits
    aDepTitle: 'Quản lý Nạp tiền',
    aDepSubtitle: 'Duyệt và quản lý yêu cầu nạp tiền',
    aDepAll: 'Tất cả',
    aDepPending: 'Chờ duyệt',
    aDepApprovedLabel: 'Đã duyệt',
    aDepRejectedLabel: 'Từ chối',
    aDepUser: 'Người dùng',
    aDepAmount: 'Số tiền',
    aDepMethod: 'Phương thức',
    aDepStatus: 'Trạng thái',
    aDepDate: 'Ngày',
    aDepActions: 'Hành động',
    aDepLoading: 'Đang tải...',
    aDepEmpty: 'Không có yêu cầu nào',
    aDepDefaultMethod: 'Bank Transfer',
    aDepProcessing: 'Đang xử lý...',
    aDepApprove: 'Duyệt',
    aDepPaginationTotal: 'Tổng {total} yêu cầu · Trang {page}/{pages}',
    aDepPrev: 'Trước',
    aDepNext: 'Sau',
    aDepApproveConfirm: 'Xác nhận duyệt yêu cầu nạp tiền này?',
    aDepApproved: 'Đã duyệt yêu cầu nạp tiền!',
    aDepRejectConfirm: 'Xác nhận từ chối yêu cầu nạp tiền này?',
    aDepRejected: 'Đã từ chối yêu cầu nạp tiền!',
    // AdminWithdrawals
    aWdTitle: 'Quản lý Rút tiền',
    aWdSubtitle: 'Duyệt và quản lý yêu cầu rút tiền',
    aWdPendingCount: '{n} yêu cầu',
    aWdPendingSuffix: 'đang chờ duyệt',
    aWdAll: 'Tất cả',
    aWdPending: 'Chờ duyệt',
    aWdCompleted: 'Hoàn thành',
    aWdRejected: 'Từ chối',
    aWdUser: 'Người dùng',
    aWdAmount: 'Số tiền',
    aWdReceiveMethod: 'Phương thức nhận',
    aWdStatus: 'Trạng thái',
    aWdDate: 'Ngày',
    aWdActions: 'Hành động',
    aWdLoading: 'Đang tải...',
    aWdEmpty: 'Không có yêu cầu nào',
    aWdCopyWallet: 'Copy ví',
    aWdCopyStk: 'Copy STK',
    aWdProcessing: 'Đang xử lý...',
    aWdApprove: 'Duyệt',
    aWdPaginationTotal: 'Tổng {total} yêu cầu · Trang {page}/{pages}',
    aWdPrev: 'Trước',
    aWdNext: 'Sau',
    aWdApproveConfirm: 'Xác nhận đã chuyển tiền và duyệt yêu cầu rút tiền này?',
    aWdApproved: 'Đã duyệt yêu cầu rút tiền!',
    aWdRejectConfirm: 'Xác nhận từ chối yêu cầu rút tiền này? Tiền sẽ được hoàn lại.',
    aWdRejectedRefunded: 'Đã từ chối và hoàn tiền!',
    // AdminKyc
    aKycTitle: 'Xác minh danh tính',
    aKycSubtitle: 'Duyệt yêu cầu xác minh danh tính',
    aKycAll: 'Tất cả',
    aKycPending: 'Chờ duyệt',
    aKycApproved: 'Đã duyệt',
    aKycRejected: 'Từ chối',
    aKycUser: 'Người dùng',
    aKycRealName: 'Họ tên',
    aKycPhone: 'Điện thoại',
    aKycIdPhotos: 'Giấy tờ',
    aKycStatus: 'Trạng thái',
    aKycDate: 'Ngày',
    aKycActions: 'Hành động',
    aKycLoading: 'Đang tải...',
    aKycEmpty: 'Không có yêu cầu nào',
    aKycPendingCount: '{n} yêu cầu',
    aKycPendingSuffix: 'đang chờ duyệt',
    aKycApprove: 'Duyệt',
    aKycApproveConfirm: 'Xác nhận duyệt yêu cầu xác minh này?',
    aKycApprovedMsg: 'Đã duyệt xác minh!',
    aKycRejectAsk: 'Nhập lý do từ chối (hiển thị cho người dùng):',
    aKycRejectedMsg: 'Đã từ chối xác minh!',
    aKycPaginationTotal: 'Tổng {total} yêu cầu · Trang {page}/{pages}',
    aKycPrev: 'Trước',
    aKycNext: 'Sau',
    aSocialTitle: 'Tài khoản MXH',
    aSocialSubtitle: 'Duyệt yêu cầu liên kết tài khoản mạng xã hội',
    aSocialAll: 'Tất cả',
    aSocialPending: 'Chờ duyệt',
    aSocialApproved: 'Đã duyệt',
    aSocialRejected: 'Từ chối',
    aSocialUser: 'Người dùng',
    aSocialPlatform: 'Nền tảng',
    aSocialAccount: 'Tài khoản',
    aSocialStatus: 'Trạng thái',
    aSocialPendingCount: '{n} yêu cầu',
    aSocialPendingSuffix: 'đang chờ duyệt',
    aSocialApproveConfirm: 'Xác nhận duyệt yêu cầu liên kết này?',
    aSocialApprovedMsg: 'Đã duyệt liên kết!',
    aSocialRejectAsk: 'Nhập lý do từ chối (hiển thị cho người dùng):',
    aSocialRejectedMsg: 'Đã từ chối liên kết!'
  },
  en: {
    // AdminOrders
    aOrdsTitle: 'Order Management',
    aOrdsSubtitle: 'Add and manage orders in the pool',
    aOrdsAddOrder: 'Add Order',
    aOrdsPoolTitle: 'Order Pool',
    aOrdsPoolSubtitle: 'Manage all products in the pool',
    aOrdsTotalOrders: 'Total Orders',
    aOrdsActive: 'Active',
    aOrdsTotalCommission: 'Total Commission',
    aOrdsLoading: 'Loading...',
    aOrdsEmpty: 'No orders in the pool yet',
    aOrdsStatusActive: 'Active',
    aOrdsStatusInactive: 'Paused',
    aOrdsPrice: 'Price:',
    aOrdsCommission: 'Commission:',
    aOrdsEdit: 'Edit',
    aOrdsDelete: 'Delete',
    aOrdsEditOrder: 'Edit Order',
    aOrdsAddNew: 'Add New Order',
    aOrdsProductName: 'Product Name',
    aOrdsProductNamePlaceholder: 'e.g. iPhone 15 Pro Max',
    aOrdsProductImage: 'Product Image',
    aOrdsChooseImage: 'Choose image',
    aOrdsPriceUsdt: 'Price (USDT)',
    aOrdsCommissionHint: "Commission is automatically calculated based on the user's VIP level percentage.",
    aOrdsStatus: 'Status',
    aOrdsCancel: 'Cancel',
    aOrdsProcessing: 'Processing...',
    aOrdsUpdate: 'Update',
    aOrdsUpdateSuccess: 'Order updated successfully!',
    aOrdsCreateSuccess: 'Order added successfully!',
    aOrdsErrorOccurred: 'An error occurred!',
    aOrdsDeleteConfirm: 'Are you sure you want to delete this order?',
    aOrdsDeleteSuccess: 'Order deleted successfully!',
    aOrdsDeleteFailed: 'Unable to delete the order!',
    // AdminDeposits
    aDepTitle: 'Deposit Management',
    aDepSubtitle: 'Review and manage deposit requests',
    aDepAll: 'All',
    aDepPending: 'Pending',
    aDepApprovedLabel: 'Approved',
    aDepRejectedLabel: 'Rejected',
    aDepUser: 'User',
    aDepAmount: 'Amount',
    aDepMethod: 'Method',
    aDepStatus: 'Status',
    aDepDate: 'Date',
    aDepActions: 'Actions',
    aDepLoading: 'Loading...',
    aDepEmpty: 'No requests found',
    aDepDefaultMethod: 'Bank Transfer',
    aDepProcessing: 'Processing...',
    aDepApprove: 'Approve',
    aDepPaginationTotal: 'Total {total} requests · Page {page}/{pages}',
    aDepPrev: 'Previous',
    aDepNext: 'Next',
    aDepApproveConfirm: 'Approve this deposit request?',
    aDepApproved: 'Deposit request approved!',
    aDepRejectConfirm: 'Reject this deposit request?',
    aDepRejected: 'Deposit request rejected!',
    // AdminWithdrawals
    aWdTitle: 'Withdrawal Management',
    aWdSubtitle: 'Review and manage withdrawal requests',
    aWdPendingCount: '{n} requests',
    aWdPendingSuffix: 'awaiting approval',
    aWdAll: 'All',
    aWdPending: 'Pending',
    aWdCompleted: 'Completed',
    aWdRejected: 'Rejected',
    aWdUser: 'User',
    aWdAmount: 'Amount',
    aWdReceiveMethod: 'Payout Method',
    aWdStatus: 'Status',
    aWdDate: 'Date',
    aWdActions: 'Actions',
    aWdLoading: 'Loading...',
    aWdEmpty: 'No requests found',
    aWdCopyWallet: 'Copy wallet address',
    aWdCopyStk: 'Copy account number',
    aWdProcessing: 'Processing...',
    aWdApprove: 'Approve',
    aWdPaginationTotal: 'Total {total} requests · Page {page}/{pages}',
    aWdPrev: 'Previous',
    aWdNext: 'Next',
    aWdApproveConfirm: 'Confirm the transfer has been made and approve this withdrawal request?',
    aWdApproved: 'Withdrawal request approved!',
    aWdRejectConfirm: 'Reject this withdrawal request? The funds will be refunded.',
    aWdRejectedRefunded: 'Rejected and refunded!',
    // AdminKyc
    aKycTitle: 'Identity Verification',
    aKycSubtitle: 'Review identity verification requests',
    aKycAll: 'All',
    aKycPending: 'Pending',
    aKycApproved: 'Approved',
    aKycRejected: 'Rejected',
    aKycUser: 'User',
    aKycRealName: 'Real name',
    aKycPhone: 'Phone',
    aKycIdPhotos: 'ID photos',
    aKycStatus: 'Status',
    aKycDate: 'Date',
    aKycActions: 'Actions',
    aKycLoading: 'Loading...',
    aKycEmpty: 'No requests',
    aKycPendingCount: '{n} requests',
    aKycPendingSuffix: 'awaiting review',
    aKycApprove: 'Approve',
    aKycApproveConfirm: 'Approve this verification request?',
    aKycApprovedMsg: 'Verification approved!',
    aKycRejectAsk: 'Reason for rejection (shown to the user):',
    aKycRejectedMsg: 'Verification rejected!',
    aKycPaginationTotal: 'Total {total} requests · Page {page}/{pages}',
    aKycPrev: 'Prev',
    aKycNext: 'Next',
    aSocialTitle: 'Social Accounts',
    aSocialSubtitle: 'Review social account link requests',
    aSocialAll: 'All',
    aSocialPending: 'Pending',
    aSocialApproved: 'Approved',
    aSocialRejected: 'Rejected',
    aSocialUser: 'User',
    aSocialPlatform: 'Platform',
    aSocialAccount: 'Account',
    aSocialStatus: 'Status',
    aSocialPendingCount: '{n} requests',
    aSocialPendingSuffix: 'awaiting review',
    aSocialApproveConfirm: 'Approve this link request?',
    aSocialApprovedMsg: 'Link approved!',
    aSocialRejectAsk: 'Enter rejection reason (shown to user):',
    aSocialRejectedMsg: 'Link rejected!'
  },
  ko: {
    // AdminOrders
    aOrdsTitle: '주문 관리',
    aOrdsSubtitle: '풀 내 주문 추가 및 관리',
    aOrdsAddOrder: '주문 추가',
    aOrdsPoolTitle: '주문 풀',
    aOrdsPoolSubtitle: '풀 내 전체 상품 관리',
    aOrdsTotalOrders: '총 주문',
    aOrdsActive: '활성',
    aOrdsTotalCommission: '총 커미션',
    aOrdsLoading: '로딩 중...',
    aOrdsEmpty: '풀에 주문이 없습니다',
    aOrdsStatusActive: '활성',
    aOrdsStatusInactive: '일시 중지',
    aOrdsPrice: '가격:',
    aOrdsCommission: '커미션:',
    aOrdsEdit: '수정',
    aOrdsDelete: '삭제',
    aOrdsEditOrder: '주문 수정',
    aOrdsAddNew: '새 주문 추가',
    aOrdsProductName: '상품명',
    aOrdsProductNamePlaceholder: '예: iPhone 15 Pro Max',
    aOrdsProductImage: '상품 이미지',
    aOrdsChooseImage: '이미지 선택',
    aOrdsPriceUsdt: '가격 (USDT)',
    aOrdsCommissionHint: '커미션은 사용자의 VIP 등급 설정 비율에 따라 자동 계산됩니다.',
    aOrdsStatus: '상태',
    aOrdsCancel: '취소',
    aOrdsProcessing: '처리 중...',
    aOrdsUpdate: '업데이트',
    aOrdsUpdateSuccess: '주문이 수정되었습니다!',
    aOrdsCreateSuccess: '주문이 추가되었습니다!',
    aOrdsErrorOccurred: '오류가 발생했습니다!',
    aOrdsDeleteConfirm: '이 주문을 삭제하시겠습니까?',
    aOrdsDeleteSuccess: '주문이 삭제되었습니다!',
    aOrdsDeleteFailed: '주문을 삭제할 수 없습니다!',
    // AdminDeposits
    aDepTitle: '입금 관리',
    aDepSubtitle: '입금 요청 심사 및 관리',
    aDepAll: '전체',
    aDepPending: '심사 대기',
    aDepApprovedLabel: '승인됨',
    aDepRejectedLabel: '거절됨',
    aDepUser: '사용자',
    aDepAmount: '금액',
    aDepMethod: '수단',
    aDepStatus: '상태',
    aDepDate: '날짜',
    aDepActions: '관리',
    aDepLoading: '로딩 중...',
    aDepEmpty: '요청이 없습니다',
    aDepDefaultMethod: 'Bank Transfer',
    aDepProcessing: '처리 중...',
    aDepApprove: '승인',
    aDepPaginationTotal: '총 {total}건 요청 · 페이지 {page}/{pages}',
    aDepPrev: '이전',
    aDepNext: '다음',
    aDepApproveConfirm: '이 입금 요청을 승인하시겠습니까?',
    aDepApproved: '입금 요청이 승인되었습니다!',
    aDepRejectConfirm: '이 입금 요청을 거절하시겠습니까?',
    aDepRejected: '입금 요청이 거절되었습니다!',
    // AdminWithdrawals
    aWdTitle: '출금 관리',
    aWdSubtitle: '출금 요청 심사 및 관리',
    aWdPendingCount: '{n}건',
    aWdPendingSuffix: '심사 대기 중',
    aWdAll: '전체',
    aWdPending: '심사 대기',
    aWdCompleted: '완료',
    aWdRejected: '거절됨',
    aWdUser: '사용자',
    aWdAmount: '금액',
    aWdReceiveMethod: '수령 수단',
    aWdStatus: '상태',
    aWdDate: '날짜',
    aWdActions: '관리',
    aWdLoading: '로딩 중...',
    aWdEmpty: '요청이 없습니다',
    aWdCopyWallet: '지갑 주소 복사',
    aWdCopyStk: '계좌번호 복사',
    aWdProcessing: '처리 중...',
    aWdApprove: '승인',
    aWdPaginationTotal: '총 {total}건 요청 · 페이지 {page}/{pages}',
    aWdPrev: '이전',
    aWdNext: '다음',
    aWdApproveConfirm: '송금을 완료하고 이 출금 요청을 승인하시겠습니까?',
    aWdApproved: '출금 요청이 승인되었습니다!',
    aWdRejectConfirm: '이 출금 요청을 거절하시겠습니까? 금액이 환불됩니다.',
    aWdRejectedRefunded: '거절 및 환불 완료!',
    // AdminKyc
    aKycTitle: '본인 인증',
    aKycSubtitle: '본인 인증 요청 심사',
    aKycAll: '전체',
    aKycPending: '대기',
    aKycApproved: '승인',
    aKycRejected: '거절',
    aKycUser: '사용자',
    aKycRealName: '실명',
    aKycPhone: '전화번호',
    aKycIdPhotos: '신분증 사진',
    aKycStatus: '상태',
    aKycDate: '날짜',
    aKycActions: '작업',
    aKycLoading: '불러오는 중...',
    aKycEmpty: '요청이 없습니다',
    aKycPendingCount: '{n}건',
    aKycPendingSuffix: '심사 대기 중',
    aKycApprove: '승인',
    aKycApproveConfirm: '이 인증 요청을 승인하시겠습니까?',
    aKycApprovedMsg: '인증이 승인되었습니다!',
    aKycRejectAsk: '거절 사유 (사용자에게 표시):',
    aKycRejectedMsg: '인증이 거절되었습니다!',
    aKycPaginationTotal: '총 {total}건 · 페이지 {page}/{pages}',
    aKycPrev: '이전',
    aKycNext: '다음',
    aSocialTitle: '소셜 계정',
    aSocialSubtitle: '소셜 계정 연결 신청 심사',
    aSocialAll: '전체',
    aSocialPending: '심사 대기',
    aSocialApproved: '승인',
    aSocialRejected: '거절',
    aSocialUser: '사용자',
    aSocialPlatform: '플랫폼',
    aSocialAccount: '계정',
    aSocialStatus: '상태',
    aSocialPendingCount: '{n}건',
    aSocialPendingSuffix: '심사 대기 중',
    aSocialApproveConfirm: '이 연결 신청을 승인하시겠습니까?',
    aSocialApprovedMsg: '연결이 승인되었습니다!',
    aSocialRejectAsk: '거절 사유를 입력하세요 (사용자에게 표시됨):',
    aSocialRejectedMsg: '연결이 거절되었습니다!'
  },
  ja: {
    // AdminOrders
    aOrdsTitle: '注文管理',
    aOrdsSubtitle: 'プール内の注文の追加と管理',
    aOrdsAddOrder: '注文を追加',
    aOrdsPoolTitle: '注文プール',
    aOrdsPoolSubtitle: 'プール内の全商品を管理',
    aOrdsTotalOrders: '総注文数',
    aOrdsActive: '稼働中',
    aOrdsTotalCommission: '総コミッション',
    aOrdsLoading: '読み込み中...',
    aOrdsEmpty: 'プールに注文がありません',
    aOrdsStatusActive: '稼働',
    aOrdsStatusInactive: '一時停止',
    aOrdsPrice: '価格:',
    aOrdsCommission: 'コミッション:',
    aOrdsEdit: '編集',
    aOrdsDelete: '削除',
    aOrdsEditOrder: '注文を編集',
    aOrdsAddNew: '新規注文を追加',
    aOrdsProductName: '商品名',
    aOrdsProductNamePlaceholder: '例: iPhone 15 Pro Max',
    aOrdsProductImage: '商品画像',
    aOrdsChooseImage: '画像を選択',
    aOrdsPriceUsdt: '価格 (USDT)',
    aOrdsCommissionHint: 'コミッションはユーザーのVIP設定の割合に基づき自動計算されます。',
    aOrdsStatus: 'ステータス',
    aOrdsCancel: 'キャンセル',
    aOrdsProcessing: '処理中...',
    aOrdsUpdate: '更新',
    aOrdsUpdateSuccess: '注文を更新しました！',
    aOrdsCreateSuccess: '注文を追加しました！',
    aOrdsErrorOccurred: 'エラーが発生しました！',
    aOrdsDeleteConfirm: 'この注文を削除してもよろしいですか？',
    aOrdsDeleteSuccess: '注文を削除しました！',
    aOrdsDeleteFailed: '注文を削除できません！',
    // AdminDeposits
    aDepTitle: '入金管理',
    aDepSubtitle: '入金リクエストの承認と管理',
    aDepAll: 'すべて',
    aDepPending: '承認待ち',
    aDepApprovedLabel: '承認済み',
    aDepRejectedLabel: '却下',
    aDepUser: 'ユーザー',
    aDepAmount: '金額',
    aDepMethod: '方法',
    aDepStatus: 'ステータス',
    aDepDate: '日時',
    aDepActions: '操作',
    aDepLoading: '読み込み中...',
    aDepEmpty: 'リクエストがありません',
    aDepDefaultMethod: 'Bank Transfer',
    aDepProcessing: '処理中...',
    aDepApprove: '承認',
    aDepPaginationTotal: '合計 {total} 件 · {page}/{pages} ページ',
    aDepPrev: '前へ',
    aDepNext: '次へ',
    aDepApproveConfirm: 'この入金リクエストを承認しますか？',
    aDepApproved: '入金リクエストを承認しました！',
    aDepRejectConfirm: 'この入金リクエストを却下しますか？',
    aDepRejected: '入金リクエストを却下しました！',
    // AdminWithdrawals
    aWdTitle: '出金管理',
    aWdSubtitle: '出金リクエストの承認と管理',
    aWdPendingCount: '{n}件',
    aWdPendingSuffix: 'が承認待ちです',
    aWdAll: 'すべて',
    aWdPending: '承認待ち',
    aWdCompleted: '完了',
    aWdRejected: '却下',
    aWdUser: 'ユーザー',
    aWdAmount: '金額',
    aWdReceiveMethod: '受取方法',
    aWdStatus: 'ステータス',
    aWdDate: '日時',
    aWdActions: '操作',
    aWdLoading: '読み込み中...',
    aWdEmpty: 'リクエストがありません',
    aWdCopyWallet: 'ウォレットアドレスをコピー',
    aWdCopyStk: '口座番号をコピー',
    aWdProcessing: '処理中...',
    aWdApprove: '承認',
    aWdPaginationTotal: '合計 {total} 件 · {page}/{pages} ページ',
    aWdPrev: '前へ',
    aWdNext: '次へ',
    aWdApproveConfirm: '送金を完了済みとして、この出金リクエストを承認しますか？',
    aWdApproved: '出金リクエストを承認しました！',
    aWdRejectConfirm: 'この出金リクエストを却下しますか？ 金額は返金されます。',
    aWdRejectedRefunded: '却下し、返金しました！',
    // AdminKyc
    aKycTitle: '本人確認',
    aKycSubtitle: '本人確認リクエストの審査',
    aKycAll: 'すべて',
    aKycPending: '審査待ち',
    aKycApproved: '承認済み',
    aKycRejected: '却下',
    aKycUser: 'ユーザー',
    aKycRealName: '氏名',
    aKycPhone: '電話番号',
    aKycIdPhotos: '証明書写真',
    aKycStatus: 'ステータス',
    aKycDate: '日付',
    aKycActions: '操作',
    aKycLoading: '読み込み中...',
    aKycEmpty: 'リクエストはありません',
    aKycPendingCount: '{n}件',
    aKycPendingSuffix: '審査待ちです',
    aKycApprove: '承認',
    aKycApproveConfirm: 'この確認リクエストを承認しますか?',
    aKycApprovedMsg: '承認しました!',
    aKycRejectAsk: '却下理由（ユーザーに表示）:',
    aKycRejectedMsg: '却下しました!',
    aKycPaginationTotal: '合計{total}件 · ページ{page}/{pages}',
    aKycPrev: '前へ',
    aKycNext: '次へ',
    aSocialTitle: 'SNSアカウント',
    aSocialSubtitle: 'SNSアカウント連携申請の審査',
    aSocialAll: 'すべて',
    aSocialPending: '審査待ち',
    aSocialApproved: '承認済み',
    aSocialRejected: '却下',
    aSocialUser: 'ユーザー',
    aSocialPlatform: 'プラットフォーム',
    aSocialAccount: 'アカウント',
    aSocialStatus: 'ステータス',
    aSocialPendingCount: '{n}件',
    aSocialPendingSuffix: '審査待ちです',
    aSocialApproveConfirm: 'この連携申請を承認しますか？',
    aSocialApprovedMsg: '承認しました！',
    aSocialRejectAsk: '却下理由を入力してください（ユーザーに表示されます）:',
    aSocialRejectedMsg: '却下しました！'
  },
  zh: {
    // AdminOrders
    aOrdsTitle: '订单管理',
    aOrdsSubtitle: '添加并管理订单池中的订单',
    aOrdsAddOrder: '添加订单',
    aOrdsPoolTitle: '订单池',
    aOrdsPoolSubtitle: '管理订单池中的全部商品',
    aOrdsTotalOrders: '订单总数',
    aOrdsActive: '进行中',
    aOrdsTotalCommission: '佣金总额',
    aOrdsLoading: '加载中...',
    aOrdsEmpty: '订单池中暂无订单',
    aOrdsStatusActive: '启用',
    aOrdsStatusInactive: '暂停',
    aOrdsPrice: '价格:',
    aOrdsCommission: '佣金:',
    aOrdsEdit: '编辑',
    aOrdsDelete: '删除',
    aOrdsEditOrder: '编辑订单',
    aOrdsAddNew: '新增订单',
    aOrdsProductName: '商品名称',
    aOrdsProductNamePlaceholder: '例如: iPhone 15 Pro Max',
    aOrdsProductImage: '商品图片',
    aOrdsChooseImage: '选择图片',
    aOrdsPriceUsdt: '价格 (USDT)',
    aOrdsCommissionHint: '佣金根据用户的 VIP 等级配置比例自动计算。',
    aOrdsStatus: '状态',
    aOrdsCancel: '取消',
    aOrdsProcessing: '处理中...',
    aOrdsUpdate: '更新',
    aOrdsUpdateSuccess: '订单更新成功!',
    aOrdsCreateSuccess: '订单添加成功!',
    aOrdsErrorOccurred: '发生错误!',
    aOrdsDeleteConfirm: '确定要删除此订单吗?',
    aOrdsDeleteSuccess: '订单删除成功!',
    aOrdsDeleteFailed: '无法删除该订单!',
    // AdminDeposits
    aDepTitle: '充值管理',
    aDepSubtitle: '审核并管理充值申请',
    aDepAll: '全部',
    aDepPending: '待审核',
    aDepApprovedLabel: '已通过',
    aDepRejectedLabel: '已拒绝',
    aDepUser: '用户',
    aDepAmount: '金额',
    aDepMethod: '方式',
    aDepStatus: '状态',
    aDepDate: '日期',
    aDepActions: '操作',
    aDepLoading: '加载中...',
    aDepEmpty: '暂无申请',
    aDepDefaultMethod: 'Bank Transfer',
    aDepProcessing: '处理中...',
    aDepApprove: '通过',
    aDepPaginationTotal: '共 {total} 条申请 · 第 {page}/{pages} 页',
    aDepPrev: '上一页',
    aDepNext: '下一页',
    aDepApproveConfirm: '确定通过此充值申请吗?',
    aDepApproved: '充值申请已通过!',
    aDepRejectConfirm: '确定拒绝此充值申请吗?',
    aDepRejected: '充值申请已拒绝!',
    // AdminWithdrawals
    aWdTitle: '提现管理',
    aWdSubtitle: '审核并管理提现申请',
    aWdPendingCount: '{n} 条',
    aWdPendingSuffix: '待审核',
    aWdAll: '全部',
    aWdPending: '待审核',
    aWdCompleted: '已完成',
    aWdRejected: '已拒绝',
    aWdUser: '用户',
    aWdAmount: '金额',
    aWdReceiveMethod: '收款方式',
    aWdStatus: '状态',
    aWdDate: '日期',
    aWdActions: '操作',
    aWdLoading: '加载中...',
    aWdEmpty: '暂无申请',
    aWdCopyWallet: '复制钱包地址',
    aWdCopyStk: '复制账号',
    aWdProcessing: '处理中...',
    aWdApprove: '通过',
    aWdPaginationTotal: '共 {total} 条申请 · 第 {page}/{pages} 页',
    aWdPrev: '上一页',
    aWdNext: '下一页',
    aWdApproveConfirm: '确认已完成转账并通过此提现申请吗?',
    aWdApproved: '提现申请已通过!',
    aWdRejectConfirm: '确定拒绝此提现申请吗? 款项将退回。',
    aWdRejectedRefunded: '已拒绝并退款!',
    // AdminKyc
    aKycTitle: '实名认证',
    aKycSubtitle: '审核实名认证申请',
    aKycAll: '全部',
    aKycPending: '待审核',
    aKycApproved: '已通过',
    aKycRejected: '已驳回',
    aKycUser: '用户',
    aKycRealName: '真实姓名',
    aKycPhone: '电话',
    aKycIdPhotos: '证件照',
    aKycStatus: '状态',
    aKycDate: '日期',
    aKycActions: '操作',
    aKycLoading: '加载中...',
    aKycEmpty: '暂无申请',
    aKycPendingCount: '{n} 条',
    aKycPendingSuffix: '等待审核',
    aKycApprove: '通过',
    aKycApproveConfirm: '确定通过此实名认证申请吗?',
    aKycApprovedMsg: '已通过认证!',
    aKycRejectAsk: '填写驳回原因（会展示给用户）:',
    aKycRejectedMsg: '已驳回!',
    aKycPaginationTotal: '共 {total} 条 · 第 {page}/{pages} 页',
    aKycPrev: '上一页',
    aKycNext: '下一页',
    aSocialTitle: '社交账号',
    aSocialSubtitle: '审核社交账号绑定申请',
    aSocialAll: '全部',
    aSocialPending: '待审核',
    aSocialApproved: '已通过',
    aSocialRejected: '已驳回',
    aSocialUser: '用户',
    aSocialPlatform: '平台',
    aSocialAccount: '账号',
    aSocialStatus: '状态',
    aSocialPendingCount: '{n} 条申请',
    aSocialPendingSuffix: '待审核',
    aSocialApproveConfirm: '确认通过该绑定申请？',
    aSocialApprovedMsg: '已通过！',
    aSocialRejectAsk: '输入驳回原因（展示给用户）：',
    aSocialRejectedMsg: '已驳回！'
  }
};

export default bizTranslations;
